<template>
  <!--    <h1>Transfer Ownership</h1>-->
  <b-modal
    id="transfer-ownership"
    ref="transfer-ownership"
    size="sm-size"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('transfer_ownership') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <ul class="admin-list">
        <li
          v-for="(item, idx) in admins"
          :key="idx"
        >
          <b-form-radio
            name="some-radios"
            @change="selectMember(item)"
          >
            <span class="member-name">
              {{ item.name }}
            </span>
          </b-form-radio>
        </li>
        <li v-if="admins.length === 0">
          <span class="member-name" v-html="label.get('need_admins_for_transfer_ownership')">
          </span>
        </li>
      </ul>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          type="reset"
          class="atto-btn cancel"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          type="submit"
          class="atto-btn submit"
          @click="transfer"
        >
          {{ label.get('transfer') }}
        </button>
      </div>
      <span
        v-if="hasError"
        class="error-message"
      >{{ label.get('please_select_one_of_the_members_above_to_complete_the_transfer') }}</span>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "TransferOwnershipModalComponent",
        props: {
          admins: {
            type: Array,
            default: () => {
              return [];
            }
          }
        },
        data() {
            return {
                member: null,
                hasError: false
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['transfer-ownership'].show();
        },
        methods: {
            close() {
                this.$root.$emit('hideTransferOwnership');
            },
            selectMember(member) {
                this.member = member;
                this.hasError = false;
            },
            transfer() {
                this.hasError = false;
                if (!this.member) {
                    this.hasError = true;
                    return false;
                }
                this.$root.$emit('hideTransferOwnership', this.member);
            }
        }
    }
</script>

<style lang="scss">
    .admin-list {
        li {
            margin-bottom: 16px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .modal-sm-size {
        .modal-footer {
            flex-direction: column;

            .form-buttons {
                margin-right: 0;
            }

            span.error-message {
                margin-left: 0;
            }
        }
    }
</style>